import {getAuditCount} from "@/api/dilivery/auditNum";

export function getRedNum(sendData, plat) {
    return new Promise((resolve, reject) => {
        resolve(getAuditCount(plat,sendData?sendData:{}));
    })
}
